import React from "react";
import { Link } from "react-router-dom";
const DownloadElement = ({
  outline,
  primary,
  secondary,
  terciary,
  right,
  cart,
  small,
  medium,
  large,
  round,
  loading,
  link,
  to,
  target,
  download,
  onClick,
  className,
  children,
  tight,
  alert,
  customSizing,
  ...rest
}) => {
  const downloadClass = [
    "gl-download",
    ((!terciary && !secondary) || primary) && "primary", //default
    secondary && "secondary", //default
    terciary && "terciary", //default
    !customSizing && ((!small && !large) || medium) && "medium body-m", //dafault
    round && "round",
    small && "small body-s",
    large && "large body-l",
    tight && "tight",
    alert && "alert",
    customSizing,
    className,
  ].join(" ");
  return (
    <button download onClick={onClick} className={downloadClass} {...rest}>
      {children}
    </button>
  );
};

const LinkElement = ({
  outline,
  primary,
  secondary,
  terciary,
  right,
  cart,
  extrasmall,
  small,
  medium,
  large,
  round,
  loading,
  link,
  to,
  target,
  download,
  onClick,
  className,
  children,
  tight,
  alert,
  success, 
  error,
  customSizing,
  ...rest
}) => {
  const linkClass = [
    "gl-link",
    ((!terciary && !secondary) || primary) && "primary", //default
    secondary && "secondary", //default
    terciary && "terciary", //default
    !customSizing && ((!extrasmall && !small && !large) || medium) && "medium body-m", //dafault
    round && "round",
    extrasmall && "extrasmall body-xxs",
    small && "small body-s",
    large && "large body-l",
    tight && "tight",
    alert && "alert",
    error && "error",
    success && "success",
    customSizing,
    className,
  ].join(" ");

  const targetFinal = target || (to && to.startsWith("http") ? "_blank" : "_self");


  return to && to.startsWith("http") ? (
    <a href={to} target={targetFinal} className={linkClass} {...rest}>
      {children}
    </a>
  ) : to ? (
    <Link to={to} target={targetFinal} className={linkClass} {...rest}>
      {children}
    </Link>
  ) : (
    <div onClick={onClick} className={linkClass} {...rest}>
      {children}
    </div>
  );
};

const ButtonElement = ({
  outline,
  primary,
  secondary,
  terciary,
  right,
  cart,
  extrasmall,
  small,
  medium,
  large,
  round,
  loading,
  link,
  to,
  target,
  download,
  onClick,
  className,
  children,
  tight,
  alert,
  success, 
  error,
  customSizing,
  ...rest
}) => {
  const buttonClass = [
    "gl-button",
    ((!terciary && !secondary) || primary) && "primary", //default
    secondary && "secondary", //default
    terciary && "terciary", //default
    !customSizing && ((!extrasmall && !small && !large) || medium) && "medium body-m", //dafault
    round && "round",
    extrasmall && "extrasmall body-xxs",
    small && "small body-s",
    large && "large body-l",
    tight && "tight",
    alert && "alert",
    error && "error",
    success && "success",
    customSizing,
    className,
  ].join(" ");
  return (
    <button onClick={onClick} className={buttonClass} {...rest}>
      {children}
    </button>
  );
};

const CustomButton = (props) => {
  const { link, download } = props;
  if (link) {
    return <LinkElement {...props} />;
  } else if (download) {
    return <DownloadElement {...props} />;
  } else return <ButtonElement {...props} />;
};

export default CustomButton;
